import {
  useCallback, useContext, useEffect, useState,
} from 'react'
import { useDispatch } from 'react-redux'
import translationGroups from 'client/constants/translationGroups'
import { addToast } from 'common_packages/assets/js/actions/uiActions'
import { toastTypes } from 'common_packages/assets/js/types/toastTypes'
import { klubbleAPI, ApiResult } from 'client/api/common'
import TranslationContext from 'client/contexts/TranslationContext'
import { setToken, logout } from 'client/api/authentication'
import { setUser } from '../actions/userActions'
import { type AuthToken } from '../types/AuthToken'

export const useLogin = () => {
  const translation = useContext(TranslationContext)
  const [errorToast, setErrorToast] = useState({ group: '', name: '' })
  const dispatch = useDispatch()

  // Make sure to only show the toast if the translations are available
  useEffect(() => {
    if (translation.translationsSet && errorToast.group && errorToast.name) {
      dispatch(addToast({
        message: translation.getTranslation(errorToast.group, errorToast.name),
        type: toastTypes.ERROR,
      }))
    }
  }, [dispatch, errorToast, translation])

  const login = useCallback(async (email?: string, password?: string, sso?: boolean): Promise<ApiResult<AuthToken>> => {
    try {
      let res
      if (email && password) {
        const payload = JSON.stringify({ email, password })
        res = await klubbleAPI.post<ApiResult<AuthToken>>('Auth/authenticate', payload, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
      } else if (sso && process.env.KLUBBLE_LOGIN_SSO_ENABLED === 'true') {
        res = await klubbleAPI.get<ApiResult<AuthToken>>('Auth/loginSSO', { withCredentials: true })
      } else {
        res = await klubbleAPI.get<ApiResult<AuthToken>>('Auth/loginguest')
      }
      if (res.data.success) {
        const authToken = res.data.data
        setToken(authToken)
        await setUser()(dispatch)
      } else if (sso && process.env.KLUBBLE_LOGIN_SSO_ENABLED === 'true') {
        logout(res.data.message)
      } else {
        setErrorToast({ group: translationGroups.form, name: res.data.message })
      }
      return res.data
    } catch (error) {
      if (error.message === 'sso-login-failed') {
        setErrorToast({ group: translationGroups.api, name: 'sso-invalid-user-entity' })
      } else {
        setErrorToast({ group: translationGroups.api, name: 'something-went-wrong' })
      }
      return null
    }
  }, [dispatch])
  return login
}
